import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LookupService } from 'src/app/share/services/lookup/lookup.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CommonService } from 'src/app/share/services/common/common.service';

@Component({
    selector: 'app-add-department',
    templateUrl: './add-department.component.html',
    styleUrl: './add-department.component.scss',
    standalone: false
})
export class AddDepartmentComponent implements OnInit, OnChanges {
  departmentFormGroup   !: FormGroup;
  verifyLoader: boolean = false;
  errorMessage: string;
  selectedDetails: any;
  selfDetails: any;
  companyId: any;
  @Input() isEdit: boolean = false;
  @Input() selectedDepartment: any;
  @Output() submitedData: EventEmitter<any> = new EventEmitter();
  @Output() closePanel: EventEmitter<any> = new EventEmitter();
  @Output() successToster: EventEmitter<any> = new EventEmitter();

  constructor(private readonly _fb: FormBuilder,
    private readonly lookupService: LookupService,
    private readonly storageService: StorageService,
    public commonService : CommonService,
  ) { }

  ngOnInit(): void {
    this.selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    if (this.selfDetails) {
      this.companyId = this.selfDetails.company
    }
    this.createFormGroup();
  }

  patchDepartmentForm(department: any) {
    if (department) {
      this.departmentFormGroup?.patchValue({
        name: department.name || ''
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDepartment'] || changes['isEdit']) {
      setTimeout(() => {
        if (this.isEdit && this.selectedDepartment) {
          this.patchDepartmentForm(this.selectedDepartment);
        } else {
          this.departmentFormGroup?.reset();
        }
      });
    }
  }

  createFormGroup() {
    this.departmentFormGroup = this._fb.group({
      name: new FormControl('', [Validators.required]),
    })
  }

  onCloseIconClick(value: any) {
    this.closePanel.emit(value);
    this.departmentFormGroup?.reset();
    this.selectedDepartment = null;
  }

  addDepartmentData() {
    this.lookupService.addDepartment({ ...this.departmentFormGroup.value }, this.companyId)?.subscribe({
      next: (res) => {
        if (res.status === "success") {
          this.successMessageFunction("Department is added Sucessfully");
        }
      },
      error: (err) => {
        this.errorMessageFunction(err?.error?.message);
      }
    })
  }

  editDepartmentData() {
    this.lookupService.editDepartment({ ...this.departmentFormGroup?.value }, this.companyId, this.selectedDepartment._id)?.subscribe({
      next: (res) => {
        if (res.status === "success") {
          this.successMessageFunction("Department is Updated Sucessfully");
        }
      },
      error: (err) => {
        this.errorMessageFunction(err.error?.message);
      }
    })
  }

  errorMessageFunction(message: any) {
    this.errorMessage = message;
    this.verifyLoader = false;
  }

  successMessageFunction(message: any) {
    this.verifyLoader = false;
    this.onCloseIconClick(false);
    this.successToster.emit(message);
  }

  onSubmit() {
    this.verifyLoader = true;
    if (this.isEdit) {
      this.editDepartmentData();
    } else {
      this.addDepartmentData();
    }
  }

}
